import { delay, put } from 'redux-saga/effects'

import { GlobalActions } from '../GlobalActions'

type Action = ReturnType<typeof GlobalActions.notifyReady>

const renderMarker = '#gestureListenerContainer'
const CaptureTrigger = '[ready for capture]'
const checkStep = 500
const maxAttempts = 5

export function* notifyReady({ payload: { attempt } }: Action) {
  const rendered = Boolean(document.querySelector(renderMarker))

  if (attempt > maxAttempts) {
    console.error('Notify ready: max attempts reached')
    return
  }

  if (rendered) {
    console.info(CaptureTrigger)
    return
  }

  yield delay(checkStep * attempt)
  yield put(GlobalActions.notifyReady({ attempt: attempt + 1 }))
}
